import { apiRequest } from "@/services/api-client";
import { QuitDuelOutput, WebAppRoutes } from "types/web-app";

export const quitDuel = (duelId: string) =>
  apiRequest<QuitDuelOutput>(`/${WebAppRoutes.QUIT_DUEL}`, {
    method: "POST",
    body: JSON.stringify({ duel_id: duelId }),
  });
